module.exports = __webpack_public_path__ + "static/media/kwsp_logo.72ce846a.png";